import React from 'react';
import c from 'classnames';
import { useTranslation } from 'react-i18next';

import { SEARCH_PATH } from '../../../../config/constants';
import ButtonWrapper from '../../../ButtonWrapper';

const MetaSearchEmptyState: React.FC = () => {
  const { t } = useTranslation('translation', { keyPrefix: 'searchkit.meta_search' });

  const classes = c('MetaSearch__EmptyState', 'Paper');

  return (
    <div className={classes}>
      <h3 className="asH4">
        {t('result_empty_title')}
      </h3>

      <p className="body--small">
        {t('result_empty_body')}
      </p>

      <ButtonWrapper type="secondary" href={SEARCH_PATH}>
        {t('result_empty_button')}
      </ButtonWrapper>
    </div>
  );
};

export default MetaSearchEmptyState;
